import algoliasearch from 'algoliasearch/lite';

import type { SearchClient } from 'algoliasearch/lite';

// These are set in the webpack and vite config files
// as well as in webpackFinal in the storybook config
export const searchClient: SearchClient = algoliasearch(
  __ALGOLIA_APP_ID__ || '',
  __ALGOLIA_API_KEY__ || '',
);
